<script setup lang="ts">
const {
  rating,
  showLabel = false,
  size = 'md'
} = defineProps<{
  rating: number
  showLabel?: boolean
  size?: 'sm' | 'md' | 'lg'
}>()
</script>

<template>
  <div class="flex items-center gap-2">
    <RatingStars :rating="rating" />
  </div>
</template>
